import React from "react";

export interface ValidationErrorIconProps {
    className?: string;
}

export interface QuestionValidationErrorIconProps extends ValidationErrorIconProps {
    /** Exclamation contrast on the filled circle; defaults to white. */
    glyphColor?: string;
}

const VIEW_BOX = "0 0 24 24";
const STROKE_WIDTH = 2;

function ExclamationGlyph({ color }: { color: string }) {
    return (
        <>
            <line
                x1="12"
                x2="12"
                y1="8"
                y2="12"
                stroke={color}
                strokeWidth={STROKE_WIDTH}
                strokeLinecap="round"
            />
            <line
                x1="12"
                x2="12.01"
                y1="16"
                y2="16"
                stroke={color}
                strokeWidth={STROKE_WIDTH}
                strokeLinecap="round"
            />
        </>
    );
}

/** Outline circle-alert — page validation banner (UseModernTheme). */
export function PageValidationErrorIcon({ className }: ValidationErrorIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox={VIEW_BOX}
            fill="none"
            stroke="currentColor"
            strokeWidth={STROKE_WIDTH}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden="true"
        >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" x2="12" y1="8" y2="12" />
            <line x1="12" x2="12.01" y1="16" y2="16" />
        </svg>
    );
}

/** Solid circle-alert — per-question validation (UseModernTheme). Same geometry as outline. */
export function QuestionValidationErrorIcon({
    className,
    glyphColor = "#FFFFFF",
}: QuestionValidationErrorIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox={VIEW_BOX}
            fill="none"
            className={className}
            aria-hidden="true"
        >
            <circle cx="12" cy="12" r="10" fill="currentColor" />
            <ExclamationGlyph color={glyphColor} />
        </svg>
    );
}
